<section>
    <app-shared-loading *ngIf="loading" [hintText]="displayMessage && loadingMessage" [dialogStyle]="displayMessage"></app-shared-loading>

    <div class="general-title">
        <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
    </div>

    <app-return-methods [itsMobileCtrl]="true" [unique]="transaction.ORDER_METHOD" (RT)="changeMethod()">
    </app-return-methods>

    <div class="contentBox embebedTransfiyaForm">
        <div class="center col-3">
            <div class="info-logo-container">
                <img src="{{ paymentInfo.logo }}" class="payment_method_no_interactive __method_brands" alt="Logo" />
            </div>
        </div>

        <div class="col-7">
            <div class="methodInfo">
                <app-return-methods [itsMobileCtrl]="false" [unique]="transaction.ORDER_METHOD" (RT)="changeMethod()">
                </app-return-methods>

                <app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>

                <div class="iframeContainer">
                    <iframe id="transfiyaIframe" [src]="iframeUrl | safe" frameborder="0" width="100%" height="100%"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>